import { create } from 'zustand';

import {
  CommonModalInitialState,
  CommonModalSize,
  CommonModalType,
} from 'models/common/CommonModal';
import { DefaultTFuncReturn, t } from 'i18next';
import { useTranslation } from 'react-i18next';

interface CommonModalState {
  modalType: CommonModalType;
  isOpen: boolean;
  title: string | DefaultTFuncReturn;
  content: JSX.Element | string | DefaultTFuncReturn;
  showCallbackResult: boolean;
  size?: CommonModalSize;
  yesButtonText?: string;
  yesCallback?: () => any;
  noCallback?: () => any;
  setCommonModalStateWhenModalOpen: (commonModalInitialState: CommonModalInitialState) => void;
  setCommonModalStateWhenModalClose: () => void;
}

export const useCommonModalStore = create<CommonModalState>((set, get) => {
  return {
    modalType: 'alert',
    isOpen: false,
    title: '',
    content: '',
    size: 'xs',
    yesButtonText: '',
    showCallbackResult: false,
    setCommonModalStateWhenModalOpen: (commonModalInitialState: CommonModalInitialState) => {
      const defaultTitle =
        commonModalInitialState.modalType === 'alert'
          ? String(t('com.label.알림', '알림'))
          : String(t('com.label.확인', '확인'));
      set({
        ...commonModalInitialState,
        isOpen: true,
        title: commonModalInitialState.title ?? defaultTitle,
      });
    },
    setCommonModalStateWhenModalClose: () => {
      set({
        isOpen: false,
        modalType: 'alert',
        content: '',
        size: 'xs',
        yesButtonText: '',
        yesCallback: undefined,
        noCallback: undefined,
        // showCallbackResult: false,
      });
    },
  };
});
